<template>
  <tr class="bg-white-1 sticky top-0 z-10">
    <th class="w-44">
      <RfSortButton
        :filtered="sort.type === 'timestamp' ? sort.value : null"
        class="h-full w-full"
        disabled
        @click="value => emit('update:sort', { type: 'timestamp', value })"
      >
        Timestamp
      </RfSortButton>
    </th>

    <template v-if="errorTab">
      <th :class="fullView ? 'w-32' : 'w-28'">
        <RfSortButton
          :filtered="sort.type === 'connector' ? sort.value : null"
          class="h-full w-full"
          disabled
          @click="value => emit('update:sort', { type: 'connector', value })"
        >
          Connector
        </RfSortButton>
      </th>

      <th :class="'w-80'">
        <RfSortButton
          :filtered="sort.type === 'message' ? sort.value : null"
          class="h-full w-full"
          disabled
          @click="value => emit('update:sort', { type: 'message', value })"
        >
          Message
        </RfSortButton>
      </th>
    </template>

    <th v-else class="text-left" :class="fullView ? 'w-52' : 'w-36'">
      <RfFilter
        hideIcon
        tableStyle
        :explicit="!fullView"
        maxHeight="250px"
        class="rf-header--activities [&.rf-menu]:justify-start"
        activator="Activity"
        :groups="{ activities: { el: allActivities, key: 'key', value: 'value' } }"
        :selected="filters"
        @selected="items => emit('update:filters', { ...filters, ...items })"
      />
    </th>

    <th v-if="fullView" class="w-80">
      <RfSortButton
        :filtered="sort.type === 'prompt_name' ? sort.value : null"
        class="h-full w-full whitespace-nowrap"
        disabled
        @click="value => emit('update:sort', { type: 'prompt_name', value })"
      >
        Prompt name
      </RfSortButton>
    </th>
    <th v-if="survey" :class="fullView ? 'w-52' : 'w-36'">
      <RfSortButton
        :filtered="sort.type === 'survey_option' ? sort.value : null"
        class="h-full w-full"
        disabled
        @click="value => emit('update:sort', { type: 'survey_option', value })"
      >
        Survey Option
      </RfSortButton>
    </th>
    <th class="w-32">
      <RfSortButton
        :filtered="sort.type === 'additional' ? sort.value : null"
        class="h-full w-full"
        disabled
        @click="value => emit('update:sort', { type: 'additional', value })"
      >
        Additional info
      </RfSortButton>
    </th>
    <th :class="fullView ? 'w-80' : 'w-64'">
      <RfSortButton
        :filtered="sort.type === 'user_id' ? sort.value : null"
        class="h-full w-full"
        disabled
        @click="value => emit('update:sort', { type: 'user_id', value })"
      >
        User ID
      </RfSortButton>
    </th>
  </tr>
</template>

<script setup>
import RfSortButton from "@/components/buttons/RfSortButton.vue";
import RfFilter from "@/components/inputs/RfFilter.vue";

defineProps({
  fullView: { type: Boolean, default: false },
  sort: { type: Object, default: null },
  filters: { type: Object, default: null },
  allActivities: { type: Object, default: () => ({}) },
  errorTab: { type: Boolean, default: false },
  survey: { type: Boolean, default: false },
});
const emit = defineEmits(["update:sort", "update:filters"]);
</script>
